import { render, staticRenderFns } from "./SamlLoginForm.vue?vue&type=template&id=eddf0408&"
import script from "./SamlLoginForm.vue?vue&type=script&lang=js&"
export * from "./SamlLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports